export default  {
  PendingApproval : 1,
  Approved : 2,
  Blocked : 3,
  Freezed : 4,
  Deleted : 5,
  AutoBlocked : 6,
}
